import React from 'react'
import PropTypes from 'prop-types'

const TooltipWrapper = ({
  tooltip,
  children,
  className = '',
  position = '',
  dynamic = false,
  disabled,
  focusable,
  tooltipPositionerStyle,
  tooltipWrapperStyle,
}) => (
  <div
    className={`tooltip-trigger ${className} ${dynamic ? 'dynamic' : ''} ${
      disabled ? 'disabled' : ''
    } ${focusable ? 'focusable' : ''}`}
    tabIndex={focusable ? 0 : -1}
  >
    {children}
    <div className={`tooltip-positioner ${position}`} style={tooltipPositionerStyle}>
      <span className="tooltip-wrapper" style={tooltipWrapperStyle} role="alert">
        {tooltip}
      </span>
    </div>
  </div>
)
TooltipWrapper.propTypes = {
  position: PropTypes.oneOf(['left', 'up', 'right', 'down']),
  dynamic: PropTypes.bool,
  disabled: PropTypes.bool,
}

export default TooltipWrapper



// WEBPACK FOOTER //
// ./src/components/TooltipWrapper/TooltipWrapper.js